// utils/dateFormatter.js
import React from "react";
import {
  formatDateTimePartsInTz,
  formatDateForCSVInTz,
} from "../../../../utils/cdrTimezone";

/**
 * Format date for display with colored date/time.
 * Optional `tz` argument applies a timezone conversion and appends the
 * abbreviation (e.g. "13/05/2026 04:59:00 (IST)"). Without `tz`, legacy
 * UTC display is preserved so any non-report caller keeps working.
 */
export const formatDateTimeJSXModal = (value, tz) => {
  if (!value) return "-";

  if (tz) {
    const parts = formatDateTimePartsInTz(value, tz);
    if (!parts) return "-";
    return (
      <div style={{ display: "flex", flexDirection: "row", gap: "6px", alignItems: "center" }}>
        <span style={{ color: "blue", fontSize: "13px" }}>
          {parts.datePart}
        </span>
        <span style={{ color: "green", fontSize: "13px" }}>
          {parts.timePart}
        </span>
        {parts.abbr ? (
          <span style={{ color: "#555", fontSize: "12px" }}>
            {`(${parts.abbr})`}
          </span>
        ) : null}
      </div>
    );
  }

  const date = new Date(value);
  if (isNaN(date.getTime())) return "-";

  const day = (date.getUTCDate() < 10 ? "0" : "") + date.getUTCDate();
  const month =
    (date.getUTCMonth() + 1 < 10 ? "0" : "") + (date.getUTCMonth() + 1);
  const year = date.getUTCFullYear();
  const hours = (date.getUTCHours() < 10 ? "0" : "") + date.getUTCHours();
  const minutes = (date.getUTCMinutes() < 10 ? "0" : "") + date.getUTCMinutes();
  const seconds = (date.getUTCSeconds() < 10 ? "0" : "") + date.getUTCSeconds();

  return (
    <div style={{ display: "flex", flexDirection: "row", gap: "6px" }}>
      <span style={{ color: "blue", fontSize: "13px" }}>
        {`${day}/${month}/${year}`}
      </span>
      <span style={{ color: "green", fontSize: "13px" }}>
        {`${hours}:${minutes}:${seconds}`}
      </span>
    </div>
  );
};

/**
 * Format date for CSV export (prevents Excel auto-formatting).
 * Optional `tz` argument routes through the timezone-aware helper.
 */
export const formatDateForCSV = (dateStr, tz) => {
  if (!dateStr) return "";

  if (tz) return formatDateForCSVInTz(dateStr, tz);

  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";

  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");

  // Prevent Excel from changing format
  return `="\t${day}/${month}/${year} ${hours}:${minutes}:${seconds}"`;
};

/**
 * Format date for API requests
 */
export const formatDateForAPI = (date) => {
  if (!date) return "";

  const dayjs = require("dayjs");
  return dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD HH:mm") : "";
};
